exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".u-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.UserSearchPickerOption-email {\n  color: #9ea0a3;\n  font-size: 0.875rem; }\n\n.UserSearchPickerOption.isInline .UserSearchPickerOption-name,\n.UserSearchPickerOption.isInline .UserSearchPickerOption-email {\n  display: inline-block;\n  margin-right: 16px; }\n", ""]);

// exports
